import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/new-zan-not.png'
import _imports_1 from '../assets/img/new_zan.png'


const _withScopeId = n => (_pushScopeId("data-v-7a9724a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post-item" }
const _hoisted_2 = { class: "post-info" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "fl" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = {
  key: 0,
  class: "pfsn-name"
}
const _hoisted_7 = {
  key: 1,
  class: "pfsn-name"
}
const _hoisted_8 = { class: "comment-box" }
const _hoisted_9 = {
  key: 0,
  class: "comment"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ... ")
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 2,
  class: "comment-bg book"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "comment-bg-word pl80 pt28" }
const _hoisted_16 = { class: "comment-bg-word-title" }
const _hoisted_17 = {
  key: 0,
  class: "comment-bg-word-subtitle"
}
const _hoisted_18 = { class: "comment-bg-book-total" }
const _hoisted_19 = {
  key: 3,
  class: "comment-bg run"
}
const _hoisted_20 = { class: "comment-bg-word" }
const _hoisted_21 = { class: "comment-bg-word-title" }
const _hoisted_22 = { class: "comment-bg-word-time" }
const _hoisted_23 = { class: "comment-bg-word-subtitle" }
const _hoisted_24 = { class: "content-other" }
const _hoisted_25 = { class: "dateTime" }
const _hoisted_26 = { class: "read" }
const _hoisted_27 = { class: "hotlist-opera" }
const _hoisted_28 = { class: "hotlist-opera-zan-box" }

import { ICircleInfoProps } from '@/api/type';
import { PropType } from 'vue';
import ImgBox from '../components/ImgBox.vue';
import { fullUrl, timeTransform } from '@/lib';
import { ActivityFetch } from '@/api/request';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  props: {
  postInfo: {
    type: Object as PropType<ICircleInfoProps>,
    default: () => {}
  },
  userName: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props

const router = useRouter();



const like = async(item: ICircleInfoProps) => {
  if (window.localStorage.getItem('authToken')) {
    // event.pre
    const res = await ActivityFetch.usPraise({
      fabulousNum: item.fabulous === 1 ? -1 : 1, // （用户第一次触发传1 第二触发取消点赞传 -1）
      praiseType: 3,
      praiseId: item.id,
      userName: item.nickName
    });

    if (res.code === '00') {
      item.fabulous = item.fabulous == 1 ? 0 : 1;
      item.fabulousNum = item.fabulousNum ? Number(item.fabulousNum) : 0;
      // 更新视图
      // this.$emit('uploadFn', 'update')
      if (item.fabulous) {
        if (!item.fabulousNum) {
          item.fabulousNum = 1;
        } else {
          item.fabulousNum += 1;
        }
      } else {
        item.fabulousNum -= 1;
      }
    }
  } else {
    // this.$router.push({
    //   name: "login",
    //   query: {
    //     redirect: this.$route.fullPath,
    //     inviteId: this.$route.query.token || "",
    //     scholarship: this.$route.query.scholarship || "",
    //     action: "",
    //     regChannel: this.$route.query.regChannel || "",
    //     regOrigin: this.$route.query.regOrigin || "23",
    //   },
    // });
  }
};
const toDetail = async(item: ICircleInfoProps) => {
  router.push({
    name: 'circleDetail',
    query: {
      id: item.id
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(fullUrl)(props.postInfo?.headUrl),
        class: "user-head-img"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(props?.userName ||
            props.postInfo?.realName ||
            props.postInfo?.stdName ||
            props.postInfo?.nickName ||
            '同学'), 1),
        (props.postInfo?.unvsName && props.postInfo?.pfsnName)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(props.postInfo?.unvsName) + " · " + _toDisplayString(props.postInfo?.pfsnName), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_7, "初来乍到"))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (props.postInfo?.showText2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              innerHTML: props.postInfo?.scText2
            }, null, 8, _hoisted_10),
            _hoisted_11,
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (props.postInfo.showText2 = false))
            }, "全文")
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "comment",
            innerHTML: props.postInfo?.scText
          }, null, 8, _hoisted_12)),
      _createVNode(ImgBox, {
        picUrl: props.postInfo?.picUrl
      }, null, 8, ["picUrl"]),
      (__props.postInfo?.subType === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("img", {
              src: 
            'https://yzims.oss-cn-shenzhen.aliyuncs.com/' +
            __props.postInfo.extContent.bookUrl
          ,
              alt: "",
              class: "comment-bg-book"
            }, null, 8, _hoisted_14),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, " 阅读·" + _toDisplayString(__props.postInfo.extContent.bookName), 1),
              (
              __props.postInfo.extContent.readPersonNum &&
              __props.postInfo.extContent.readPersonNum !== '0'
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 累计发布读书笔记" + _toDisplayString(__props.postInfo.extContent.totalReadNum) + "篇，超越了" + _toDisplayString(__props.postInfo.extContent.transcendNum) + "%的上进青年 ", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", null, _toDisplayString(__props.postInfo.extContent.readPersonNum) + "名书友在看这本书", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.postInfo?.subType === 2 && __props.postInfo?.extContent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", {
              style: _normalizeStyle({
            background:
              'url(' +
              'https://yzims.oss-cn-shenzhen.aliyuncs.com/' +
              __props.postInfo.extContent.runImg +
              ') repeat-x bottom'
          }),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showImgClick(0, [__props.postInfo.extContent.runImg])), ["stop"])),
              class: "comment-bg-run"
            }, null, 4),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, " 今日跑步·" + _toDisplayString(__props.postInfo.extContent.distance) + "KM ", 1),
              _createElementVNode("div", _hoisted_22, [
                _createTextVNode(" 跑步用时" + _toDisplayString(__props.postInfo.extContent.runTime) + " ", 1),
                _createElementVNode("span", null, "·配速" + _toDisplayString(__props.postInfo.extContent.spendDesc), 1)
              ]),
              _createElementVNode("div", _hoisted_23, " 今日超越了" + _toDisplayString(__props.postInfo.extContent.transcendNum) + "%的上进青年，继续加油！ ", 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(timeTransform)(props.postInfo?.createTime)), 1),
      _createElementVNode("span", _hoisted_26, "· " + _toDisplayString(props.postInfo?.readNum) + "人看过", 1),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", {
          class: "hotlist-opera-coment",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (toDetail(props.postInfo)))
        }),
        _createElementVNode("span", _hoisted_28, [
          (props.postInfo?.fabulous === '0' || !props.postInfo?.fabulous)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "hotlist-opera-zan",
                src: _imports_0,
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (like(__props.postInfo)), ["stop"]))
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _imports_1,
                class: "hotlist-opera-zan",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (like(__props.postInfo)), ["stop"]))
              })),
          _createElementVNode("span", null, _toDisplayString(props.postInfo?.fabulousNum), 1)
        ])
      ])
    ])
  ]))
}
}

})